import React from 'react';
/**
 * Context provider for the whammyDispatch() function passed down from Whammy.
 * Activity feed data actions are often dispatched from deep within the
 * component tree. Context prevents prop drilling.
 */
export const ActivityFeedWhammyDispatchContext = /*#__PURE__*/React.createContext(null);